import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
export var ReactIntlError = /*#__PURE__*/function (_Error) {
  _inherits(ReactIntlError, _Error);

  function ReactIntlError(code, message, exception) {
    var _this;

    _classCallCheck(this, ReactIntlError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactIntlError).call(this, "[React Intl Error ".concat(code, "] ").concat(message, " ").concat(exception ? "\n".concat(exception.stack) : '')));
    _this.code = code;

    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(_assertThisInitialized(_this), ReactIntlError);
    }

    return _this;
  }

  return ReactIntlError;
}( /*#__PURE__*/_wrapNativeSuper(Error));